import { useResponsive } from 'ahooks'

/**
 * 动态检测当前视窗是不是手机端屏幕
 */
export default function useBreakpoint() {
    const info = useResponsive()
    const isMobile = !info['xl']
    return isMobile
}